import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'
import logo from '../../images/site_logo/site_logo.webp'
import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {
    const location = useLocation();
    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return (

        <header className="site_header site_header_1">
            <div className="header_top text-center">
                <div className="container">
                    <p className="m-0">Subscribe us and receive <b>10% bonus</b> discount on checkout. <Link onClick={ClickHandler} to="/individual-plans"><u>Learn more</u> <i className="fa-solid fa-angle-right"></i></Link></p>
                </div>
            </div>
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-3 col-lg-2 col-5">
                            <div className="site_logo">
                                <Link onClick={ClickHandler} className="site_link" to="/">
                                    <img src={logo} alt="Site Logo – Drrived" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center" id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list justify-content-center">
                                        <li className="dropdown">
                                            <Link className="nav-link" to="#" id="portfolio_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Service
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="portfolio_submenu">
                                                <li>
                                                    <Link onClick={ClickHandler} to="/#cloud-file-storage">
                                                        <span className="icon_list_text">
                                                            Cloud File Storage
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/#cloud-pc">
                                                        <span className="icon_list_text">
                                                            Cloud PC
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/#cloud-surveillance">
                                                        <span className="icon_list_text">
                                                            Cloud Surveillance
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/#cloud-file-transfer">
                                                        <span className="icon_list_text">
                                                            Cloud File Transfer
                                                        </span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="dropdown">
                                            <Link className="nav-link" to="#" id="portfolio_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Plans
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="portfolio_submenu">
                                                <li>
                                                    <Link onClick={ClickHandler} to="/individual-plans" className={location.pathname === "/individual-plans" ? "active-link" : ""}>
                                                        <span className="icon_list_text">
                                                            Individual Plans
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/enterprise-plans" className={location.pathname === "/enterprise-plans" ? "active-link" : ""}>
                                                        <span className="icon_list_text">
                                                            Enterprise Plans
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/lifetime-plans" className={location.pathname === "/lifetime-plans" ? "active-link" : ""}>
                                                        <span className="icon_list_text">
                                                            Lifetime Plans
                                                        </span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                         <li><Link onClick={ClickHandler} to="/about" className={location.pathname === "/about" ? "active-link" : ""}>About Us</Link></li>
                                        <li><Link onClick={ClickHandler} to="/contact" className={location.pathname === "/contact" ? "active-link" : ""}>Contact Us</Link></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)} type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} className="btn btn-outline-light" to="/contact">
                                        <span className="btn_label" data-text="Get Started">Get Started</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu setMobailState={setMobailState} />
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>

    )
}

export default Header;